import fetchClient from 'lib/fetch_client'
import routes from 'server_routes'
import { getCampaignSelector } from 'redux/selectors/campaign'

import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export default function reducer(state = {}, action) {
  return state
}

export function sendDonationEmail(campaignId, transactionId) {
  return (dispatch, getState) => {
    const campaignType = getCampaignSelector(getState(), { campaignId })
      .campaign_type
    if (campaignType === CROWD_FUNDING) {
      return fetchClient()
        .request(routes.notifications.api.send_donation_email, {
          method: 'POST',
          body: {
            transactionId,
          },
        })
        .then(response => {
          // TODO fire and forget
        })
        .catch(err => {
          console.error(err) // eslint-disable-line
        })
    }
  }
}
